import React, { FC } from "react"

import { useUser } from "../data/useUser"

interface Props{
  showRules: () => void
}
export const LoginIndicator: FC<Props> = ({showRules}:Props) => {
  const { user, clearUser } = useUser()
  if (!user) return null
  return (
    <div style={{ textAlign: "right", marginBottom: 10 }}>
      {user}
      <a
        onClick={() => {
          clearUser()
          window.location.reload()
        }}
        href="#"
        style={{ marginLeft: 5 }}
      >
        switch
      </a>
      <a
        onClick={() => {
          showRules()
        }}
        href="#"
        style={{ marginLeft: 5 }}
      >
        rules
      </a>
    </div>
  )
}
